<template>
  <HeaderBase>
    <div class="flex items-center shrink header-title w-1/5">
      <span class="arrow arrow-r arrow-primary"></span>
      <b>Заказы</b>
    </div>
    <div class="shrink flex-container flex-dir-row align-center">
      <IwalyInput
        classes="border-muted-light"
        placeholder="Поиск по номеру заказа:"
        @keyup.enter.native="find"
        @blur="blur"
        v-model="value">
        <template slot="input:prepend">
          <div class="icon h-full">
            <img class="h-full" src="@/assets/icons/loupe.svg" alt="">
          </div>
        </template>
      </IwalyInput>
    </div>
  </HeaderBase>
</template>

<script>
import Input from '@/components/Input.vue';
import HeaderBase from './HeaderBase.vue';

export default {
  components: {
    HeaderBase,
    IwalyInput: Input,
  },
  data() {
    return {
      value: '',
    };
  },
  methods: {
    find(event) {
      this.$eventBus.$emit('find.order', this.value);
      event.target.blur();
    },
    blur() {
      if (this.value === '') {
        this.$eventBus.$emit('find.order', this.value);
      }
    },
  },
  mounted() {
    this.$eventBus.$on('find.order.value', (data) => {
      this.value = data;
    });
  },
  beforeDestroy() {
    this.$eventBus.$off('find.order.value');
  },
};
</script>
